import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const routerBasename = publicUrl || undefined;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={routerBasename}>
    <App />
  </BrowserRouter>
);
